export const gamesConstants = {
  LOAD: "LOBBY_GAMES_LOAD",
  LOADING: "LOBBY_GAMES_LOADING",
  LOADED: "LOBBY_GAMES_LOADED",
};
